if (!customElements.get('media-library-image')) {
  customElements.define('media-library-image', class extends HTMLElement {
    connectedCallback() {
      this.image = this.querySelector('img');
      if (!this.image) return;
      this.handleError = () => {
        if (this.dataset.fallbackSrc && !this.image.classList.contains('MediaLibrary__Image--fallback')) {
          this.image.classList.add('MediaLibrary__Image--fallback');
          this.image.removeAttribute('srcset');
          this.image.removeAttribute('sizes');
          this.image.alt = this.dataset.fallbackAlt || '';
          this.image.src = this.dataset.fallbackSrc;
        } else {
          this.image.hidden = true;
        }
      };
      this.image.addEventListener('error', this.handleError);
      if (this.image.complete && this.image.naturalWidth === 0) this.handleError();
    }

    disconnectedCallback() {
      this.image?.removeEventListener('error', this.handleError);
    }
  });
}
